<template>
  <payment-status
    @hasError="processErrorInvoice"
    @paymentInfo="setPaymentInfo"
  >
    <div slot-scope="{ paymentInfo, isLoading }">
      <loading-screen v-if="isLoading" />
      <div
        v-if="paymentInfo && paymentInfo.invoiceOrderStatus === 'Successful'"
        class="payment-info"
      >
        <template v-if="isCreatingRecurringPayment">
          <div>
            <exclamation-triangle
              scale="3"
              color="red"
              class="w-full"
            />
            <h2 class="payment-info__title">
              Revisa tu correo
            </h2>
          </div>
          <change-recurrence-notification-msisdn
            v-model="notificationNumber"
            :payment-info="paymentInfo"
          />
        </template>
        <template v-if="isInvoicePayment">
          <div>
            <img
              src="@/assets/img/exito.png"
              alt=""
            />
            <h2 class="payment-info__title">
              ¡Tu pago se ha realizado con éxito!
            </h2>
          </div>

          <payment-detail-mca
            :payment-info="paymentInfo"
            :money="country.money"
          />
        </template>
        <div class="w-full">
          <button
            class="button"
            @click="onClick"
          >
            Salir
          </button>
        </div>
      </div>
    </div>
  </payment-status>
</template>

<script>
import { mapGetters } from 'vuex';
import { ExclamationTriangle } from '@/components/icons';
import ChangeRecurrenceNotificationMsisdn from '@/views/common/Components/ChangeRecurrenceNotificationMsisdn';
import PaymentStatus from '@/views/common/RenderlessComponents/PaymentStatus';
import PaymentDetailMca from '@/views/common/Components/PaymentDetailMca';

export default {
  name: 'PaymentInfoMca',
  components: {
    PaymentStatus,
    ChangeRecurrenceNotificationMsisdn,
    ExclamationTriangle,
    PaymentDetailMca
  },
  data() {
    return {
      notificationNumber: '',
      error: '',
      payment: {}
    };
  },
  computed: {
    ...mapGetters(['country']),
    isCreatingRecurringPayment() {
      return this.payment && !!this.payment.successInfo
      && this.payment.successInfo.isCreatingRecurringPayment;
    },
    isInvoicePayment() {
      return this.payment && !!this.payment.successInfo
      && this.payment.successInfo.invoicesInfo.length > 0;
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'SetNumber' });
    },
    processErrorInvoice(paymentStatus) {
      this.$router.push({ name: 'BuyError', query: { error: paymentStatus } });
    },
    setPaymentInfo(payment) {
      this.payment = payment;
    },
    acceptNotificationMsisdn() {
      this.error = '';
      if (
        this.notificationNumber.length !== 0
        && this.notificationNumber.length !== 8
      ) {
        this.error = 'El número ingresado debe ser de 8 dígitos.';
        return;
      }
      this.isLoading = true;
      const notificationNumberWithLada = this.notificationNumber ? `${this.country.lada}${this.notificationNumber}` : '';
      global.api
        .updateRecurringPaymentNotificationMsisdn(
          this.$route.params.folio,
          notificationNumberWithLada,
          'MPCInvoice'
        )
        .then(() => {
          this.goBack();
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.error = 'El número ingresado no es Claro.';
          } else {
            this.error = 'Ha ocurrido un error, favor de intentar más tarde';
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onClick() {
      if (this.isCreatingRecurringPayment) {
        this.acceptNotificationMsisdn();
      } else { this.goBack(); }
    }
  }
};
</script>

<style lang="scss" scoped>
.payment-info {
  display: grid;
  gap: 1rem;
  text-align: center;
  width: 100%;
}
.payment-info__title {
  font-size: 1.5rem;
  line-height: 1.5;
  margin: 0;
}
.button {
  width: 75%;
  font-size: 1rem;
}
</style>
